export default __webpack_public_path__ + "static/media/FoodStore_04.d68aaeef.png";